<template>
	<div>
		<navigation></navigation>
		<div class="line"></div>
		<img src="../../../assets/phoneSchedule/top.jpg" alt="" style="width: 100%;height: auto">

		<div class="box_time">
			<!-- 大会日程 上午 -->
			<!--
      <div class="title_box" style="background-color: #fff;color:#145af5;font-size: 20px;margin-bottom: 10px;">
        会议初步日程
      </div>
	  -->
			<div style="font-family: 'Microsoft YaHei';font-weight: bold;background-color: #fff;color:#145af5;font-size: 20px;margin-top: 18px;margin-bottom: 20px;text-align: center">
				会议框架日程
			</div>
			<!-- 切换栏 -->
			<div class="big_box">
				<div class="flex qiehuanBox">
					<div class="time_qiehuan" :class="myindex==1? 'blue':''" @click="time_qiehuan">
						4月9日
					</div>
					<div class="time_qiehuan" @click="time_qiehuan2" :class="myindex==2? 'blue':''">
						4月10日
					</div>
				</div>
			</div>

			<div>
				<div v-show="myindex == 1">
					<img src="../../../assets/phoneSchedule/main.png" alt="" @click="mvenue">
					<img src="../../../assets/phoneSchedule/0409.png" alt="">
					<!-- 27日循环开始 -->
					<div v-for="(itme,index) in conferenceHall">
						<img :src="itme.url" alt="" @click="itme.fenhui!=undefined?itme.fenhui():''">
					</div>
				</div>
				<!-- 循环结束 -->

				<div v-show="myindex == 2">
					<img src="../../../assets/phoneSchedule/0410.png" alt="">
					<!-- 28日循环开始 -->
					<div v-for="(itme,index) in conferenceHall2">
						<img :src="itme.url" alt="" @click="itme.details">
					</div>
				</div>
				<!-- 2循环结束 -->
			</div>
		</div>
		<logocom></logocom>
	</div>
</template>

<script>
	import navigation from '@/components/navigation/navigation.vue';
	import logocom from '@/components/logo/logo.vue';

	export default {
		data() {
			return {
				myindex: 1,
				headimgList: [{
					url: require("@/assets/headImg/headimg.jpg"),
					id: 1
				}],
				conferenceHall: [{
						title: '分 会 场 1',
						url: require("@/assets/phoneSchedule/040901.png"),
						content: [{
								time: '13:00-15:00',
								text: '复杂性尿路感染多学科诊疗'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-16:15',
								text: '卫星会'
							},
							{
								time: '16:15-17:45',
								text: '综合医院会诊/门诊不期而遇的STD'
							}
						],
						id: 1,
						fenhui: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '1'
								}
							})
						}
					},
					{
						title: '分 会 场 2',
						url: require("@/assets/phoneSchedule/040902.png"),
						content: [{
								time: '13:00-15:00',
								text: '重症专家谈重症新冠肺炎继发感染的诊治'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-16:15',
								text: '卫星会'
							},
							{
								time: '16:15-17:45',
								text: '重症新冠肺炎医院感染的预防'
							}
						],
						id: 2,
						fenhui: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '2'
								}
							})
						}
					},
					{
						title: '分 会 场 3',
						url: require("@/assets/phoneSchedule/040903.png"),
						content: [{
								time: '13:00-15:00',
								text: 'CRO挑战与应对'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-16:15',
								text: '卫星会'
							},
							{
								time: '16:15-17:45',
								text: 'CRO挑战与应对'
							}
						],
						id: 3,
						fenhui: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '3'
								}
							})
						}
					},
					{
						title: '分 会 场 4',
						url: require("@/assets/phoneSchedule/040904.png"),
						content: [{
								time: '13:00-15:00',
								text: '儿科感染多学科诊疗'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-16:15',
								text: '卫星会'
							},
							{
								time: '16:15-17:45',
								text: '抗菌药物的经验治疗'
							}
						],
						id: 4,
						fenhui: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '4'
								}
							})
						}
					}, {
						title: '分 会 场 5',
						url: require("@/assets/phoneSchedule/040905.png"),
						content: [{
								time: '13:00-15:00',
								text: '卓越研究'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-16:15',
								text: '卫星会'
							},
							{
								time: '16:15-17:45',
								text: 'one health'
							}
						],
						id: 5,
						fenhui: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '5'
								}
							})
						}
					}, {
						title: '分 会 场 6',
						url: require("@/assets/phoneSchedule/040906.png"),
						content: [{
								time: '13:00-15:00',
								text: '临床药理'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-16:15',
								text: '卫星会'
							},
							{
								time: '16:15-17:45',
								text: 'AMS 抗生素管理'
							}
						],
						id: 6,
						fenhui: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '6'
								}
							})
						}
					}
				],
				conferenceHall2: [{
						title: '分 会 场 1',
						url: require("@/assets/phoneSchedule/041001.png"),
						morning: [{
								time: '8:00-10:00',
								text: '免疫抑制宿主肺部感染'
							},
							{
								time: '10:00-10:15',
								text: '休息'
							},
							{
								time: '10:15-11:45',
								text: '免疫抑制宿主肺部感染的治疗'
							},
							{
								time: '11:45-12:45',
								text: '卫星会'
							}
						],
						content: [{
								time: '13:00-15:00',
								text: '病例讨论'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-17:15',
								text: '病例讨论'
							}
						],
						id: 1,
						details: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '7'
								}
							})
						}

					},
					{
						title: '分 会 场 2',
						url: require("@/assets/phoneSchedule/041002.png"),
						morning: [{
								time: '8:00-10:00',
								text: '微生物检测新技术'
							},
							{
								time: '10:00-10:15',
								text: '休息'
							},
							{
								time: '10:15-11:45',
								text: '真菌与药敏折点的制定及更新'
							},
							{
								time: '11:45-12:45',
								text: '卫星会'
							}
						],
						content: [{
								time: '13:00-15:00',
								text: '微生物与临床结合之四部曲'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-17:15',
								text: '病例MDT实战：病繁菌简，柳暗花明'
							}
						],
						id: 2,
						details: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '8'
								}
							})
						}
					},
					{
						title: '分 会 场 3',
						url: require("@/assets/phoneSchedule/041003.png"),
						morning: [{
								time: '8:00-10:00',
								text: '侵袭性真菌病研究进展'
							},
							{
								time: '10:00-10:15',
								text: '休息'
							},
							{
								time: '10:15-11:45',
								text: '少见真菌病诊治进展'
							},
							{
								time: '11:45-12:45',
								text: '卫星会'
							}
						],
						content: [{
								time: '13:00-15:00',
								text: '酵母菌感染诊治进展'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-17:15',
								text: '丝状真菌感染诊治进展'
							}
						],
						id: 3,
						details: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '9'
								}
							})
						}
					},
					{
						title: '分 会 场 4',
						url: require("@/assets/phoneSchedule/041004.png"),
						morning: [{
								time: '8:00-10:00',
								text: '粒缺发热诊治进展'
							},
							{
								time: '10:00-10:15',
								text: '休息'
							},
							{
								time: '10:15-11:45',
								text: '病例讨论（突破性真菌感染）'
							},
							{
								time: '11:45-12:45',
								text: '卫星会'
							}
						],
						content: [{
								time: '13:00-15:00',
								text: '医院感染与水'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-17:15',
								text: '感染病的影像、病理诊断 '
							}
						],
						id: 4,
						details: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '10'
								}
							})
						}
					}, {
						title: '分 会 场 5',
						url: require("@/assets/phoneSchedule/041005.png"),
						morning: [{
								time: '8:00-10:00',
								text: '细菌性传染病'
							},
							{
								time: '10:00-10:15',
								text: '休息'
							},
							{
								time: '10:15-11:45',
								text: '重症与临床药学'
							},
							{
								time: '11:45-12:45',
								text: '卫星会'
							}
						],
						content: [{
								time: '13:00-15:00',
								text: '中枢神经系统感染'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-17:15',
								text: '腹腔感染诊治进展'
							}
						],
						id: 5,
						details: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '11'
								}
							})
						}
					}, {
						title: '分 会 场 6',
						url: require("@/assets/phoneSchedule/041006.png"),
						morning: [{
								time: '8:00-10:00',
								text: '青年论坛'
							},
							{
								time: '10:00-10:15',
								text: '休息'
							},
							{
								time: '10:15-11:45',
								text: '青年论坛'
							},
							{
								time: '11:45-12:45',
								text: '卫星会'
							}
						],
						content: [{
								time: '13:00-15:00',
								text: '培立方'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},

							{
								time: '15:15-17:45',
								text: ''
							}
						],
						id: 6,
						details: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '12'
								}
							})
						}
					}
				]
			}
		},
		methods: {
			retrun: function() {
				this.$router.push({
					path: '/'
				})
			},
			mvenue() {
				this.$router.push({
					path: '/details',
					query: {
						myindex: 'zuhui'
					}
				})
			},
			time_qiehuan() {
				this.myindex = 1
			},
			time_qiehuan2() {
				this.myindex = 2
			}
		},
		components: {
			navigation,
			logocom
		},
		created() {
			if (this.$route.query.id == 2) {
				this.myindex = this.$route.query.id
			}
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (!flag) {
				this.$router.push({
					path: '/schedule'
				})
			}

		},
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/style/style.scss';

	.title_box {
		width: 100%;
		height: 35px;
		background-color: #145af5;
		text-align: center;
		line-height: 70px;
		height: 70px;
		font-weight: bold;
		color: #fff;
		font-family: 'Microsoft YaHei';
	}

	.homecourt {
		background-color: #e6e6e6;
		color: #0f40d4;
		position: relative;
		font-weight: 500;
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 35px;
	}

	.look_style {
		font-weight: bold;
		font-size: 16px;
		position: absolute;
		right: 5px;
		cursor: pointer;
		color: red;
	}

	.border {
		border-top: 3px solid #cbcbcb;
		border-bottom: 3px solid #cbcbcb;
		background-color: #fff;
	}

	.box_time img {
		width: 100%;
		margin: 10px auto;
	}

	.head {
		width: 100%;
	}

	.big_box {
		height: 35px;
		line-height: 35px;
		width: 100%;
		background-color: #efefef;
		margin-bottom: 15px;
	}

	.time_qiehuan {
		font-size: 18px;
		color: #666;
		cursor: pointer;
	}

	.border_rc {
		border: 3px solid #145af5;
	}

	.qiehuanBox {
		width: 300px;
		margin: 0 auto;
		margin-bottom: 20px;
	}

	.blue {
		color: #145af5;
		font-weight: bold;
		border-bottom: 2px solid #145af5;
	}

	.phoneSchedule img {
		width: 100%;
		margin: 10px auto;
	}
</style>
